"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HToken = exports.NativeChainToken = exports.WrappedToken = exports.CanonicalToken = exports.Slug = exports.ChainSlug = exports.ChainName = exports.ChainId = exports.NetworkSlug = void 0;
var NetworkSlug;
(function (NetworkSlug) {
    NetworkSlug["Mainnet"] = "mainnet";
    NetworkSlug["Goerli"] = "goerli";
    NetworkSlug["Sepolia"] = "sepolia";
})(NetworkSlug = exports.NetworkSlug || (exports.NetworkSlug = {}));
// mainnet chain ids
var ChainId;
(function (ChainId) {
    ChainId[ChainId["Ethereum"] = 1] = "Ethereum";
    ChainId[ChainId["Optimism"] = 10] = "Optimism";
    ChainId[ChainId["Arbitrum"] = 42161] = "Arbitrum";
    ChainId[ChainId["Polygon"] = 137] = "Polygon";
    ChainId[ChainId["Gnosis"] = 100] = "Gnosis";
    ChainId[ChainId["Nova"] = 42170] = "Nova";
    ChainId[ChainId["ZkSync"] = 324] = "ZkSync";
    ChainId[ChainId["Base"] = 8453] = "Base";
    ChainId[ChainId["Linea"] = 59144] = "Linea";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
var ChainName;
(function (ChainName) {
    ChainName["Ethereum"] = "Ethereum";
    ChainName["Optimism"] = "Optimism";
    ChainName["Arbitrum"] = "Arbitrum";
    ChainName["Polygon"] = "Polygon";
    ChainName["Gnosis"] = "Gnosis";
    ChainName["Nova"] = "Nova";
    ChainName["ZkSync"] = "zkSync";
    ChainName["Linea"] = "Linea";
    ChainName["ScrollZk"] = "Scroll zkEVM";
    ChainName["Base"] = "Base";
    ChainName["PolygonZk"] = "Polygon zkEVM";
})(ChainName = exports.ChainName || (exports.ChainName = {}));
var ChainSlug;
(function (ChainSlug) {
    ChainSlug["Ethereum"] = "ethereum";
    ChainSlug["Optimism"] = "optimism";
    ChainSlug["Arbitrum"] = "arbitrum";
    ChainSlug["Polygon"] = "polygon";
    ChainSlug["Gnosis"] = "gnosis";
    ChainSlug["Nova"] = "nova";
    ChainSlug["ZkSync"] = "zksync";
    ChainSlug["Linea"] = "linea";
    ChainSlug["ScrollZk"] = "scrollzk";
    ChainSlug["Base"] = "base";
    ChainSlug["PolygonZk"] = "polygonzk";
})(ChainSlug = exports.ChainSlug || (exports.ChainSlug = {}));
var Slug;
(function (Slug) {
    Slug["ethereum"] = "ethereum";
    Slug["goerli"] = "goerli";
    Slug["sepolia"] = "sepolia";
    Slug["mainnet"] = "mainnet";
    Slug["arbitrum"] = "arbitrum";
    Slug["optimism"] = "optimism";
    Slug["gnosis"] = "gnosis";
    Slug["polygon"] = "polygon";
    Slug["nova"] = "nova";
    Slug["zksync"] = "zksync";
    Slug["linea"] = "linea";
    Slug["scrollzk"] = "scrollzk";
    Slug["base"] = "base";
    Slug["polygonzk"] = "polygonzk";
})(Slug = exports.Slug || (exports.Slug = {}));
var CanonicalToken;
(function (CanonicalToken) {
    CanonicalToken["ETH"] = "ETH";
    CanonicalToken["MATIC"] = "MATIC";
    CanonicalToken["XDAI"] = "XDAI";
    CanonicalToken["USDC"] = "USDC";
    CanonicalToken["USDT"] = "USDT";
    CanonicalToken["DAI"] = "DAI";
    CanonicalToken["WBTC"] = "WBTC";
    CanonicalToken["sBTC"] = "sBTC";
    CanonicalToken["sETH"] = "sETH";
    CanonicalToken["HOP"] = "HOP";
    CanonicalToken["SNX"] = "SNX";
    CanonicalToken["sUSD"] = "sUSD";
    CanonicalToken["rETH"] = "rETH";
    CanonicalToken["UNI"] = "UNI";
    CanonicalToken["MAGIC"] = "MAGIC";
})(CanonicalToken = exports.CanonicalToken || (exports.CanonicalToken = {}));
var WrappedToken;
(function (WrappedToken) {
    WrappedToken["WETH"] = "WETH";
    WrappedToken["WMATIC"] = "WMATIC";
    WrappedToken["WXDAI"] = "WXDAI";
})(WrappedToken = exports.WrappedToken || (exports.WrappedToken = {}));
var NativeChainToken;
(function (NativeChainToken) {
    NativeChainToken["ETH"] = "ETH";
    NativeChainToken["XDAI"] = "XDAI";
    NativeChainToken["MATIC"] = "MATIC";
})(NativeChainToken = exports.NativeChainToken || (exports.NativeChainToken = {}));
var HToken;
(function (HToken) {
    HToken["hETH"] = "hETH";
    HToken["hMATIC"] = "hMATIC";
    HToken["hUSDC"] = "hUSDC";
    HToken["hUSDT"] = "hUSDT";
    HToken["hDAI"] = "hDAI";
    HToken["hHop"] = "hHOP";
    HToken["hrETH"] = "hrETH";
    HToken["hUNI"] = "hUNI";
    HToken["hMAGIC"] = "hMAGIC";
})(HToken = exports.HToken || (exports.HToken = {}));
